/**
 * To put rest kinds of utils
 */

import { REGEX_EMAIL } from './constants';
import { TOption } from './types';

export const enumToOptions = (sourceEnum: any): TOption[] => {
  return Object.entries(sourceEnum).map(
    ([k, v]) =>
      ({
        code: k,
        label: v,
      }) as TOption,
  );
};

export const isServer = typeof window === 'undefined';
export const isClient = typeof window !== 'undefined';

export function parsedUrl() {
  const hash = location.hash;
  const urlParams = new URLSearchParams(location.search);
  return { hash, urlParams };
}

const EMAIL_URL_KEY = 'email';
export function getEmailFromUrl() {
  if (isServer) {
    return;
  }
  const { urlParams } = parsedUrl();
  const email = urlParams.get(EMAIL_URL_KEY);
  if (REGEX_EMAIL.test(email || '')) {
    return email;
  }
  return null;
}
